import React, { useState, useRef } from "react";
import { hostEventUrl } from "../config/config";


const Introduction = ({ data, buttons }) => {

    return (
        <div className="px-sm-4 px-3 font-figtree">
            <div className="text-center py-5">
                {/* Features Section */}
                {data.map((section, index) => (
                    <div
                        key={index}
                        className="d-flex justify-content-center align-items-center gap-4"
                    >
                        {/* Title and Subtitle */}
                        <div className="text-center intro-container d-flex flex-column justify-content-center align-items-center gap-2">
                            <h1 className="section-title">{section.title}</h1>
                            <p className="d-lg-block d-sm-none d-block section-subtitle mt-1">
                                {section.description}
                            </p>

                           { buttons &&<div className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center mt-4">
                                <a
                                    target="_blank"
                                    href={section.buttons.connectBtn.link}
                                    rel="noreferrer"
                                    className="exp-box"
                                >
                                    <button className="host-btn fw-bold font-sm">
                                        {section.buttons.connectBtn.name}
                                    </button>
                                </a>
                                <a
                                    target="_blank"
                                    // href={section.buttons.hostBtn.link}
                                    href={`${hostEventUrl}/create/event`}
                                    rel="noreferrer"
                                    className="exp-box"
                                >
                                    <button className="demo-btn fw-bold font-sm">
                                        {section.buttons.hostBtn.name}
                                    </button>
                                </a>
                            </div>}
                        </div>
                    </div>
                ))}
            </div>
            <style jsx>{`
                .intro-container {
                    max-width: 885px;
                    width: 100%;
                }
                .section-title {
                    font-weight: 600;
                    font-size: 36px;
                    line-height: 44px;
                    color: #101828;
                }
                .section-subtitle {
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 30px;
                    color: #475467;
                }
                .host-btn {
                    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                    font-weight: 700;
                    background-color: #002e6e;
                    color: #fff;
                    padding: 5px 40px;
                    border-radius: 4px;
                }
                .demo-btn {
                    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                    font-weight: 700;
                    color: #002e6e;
                    padding: 5px 40px;
                    border-radius: 4px;
                    border: 1px solid #002e6e;
                    background-color: #fff;
                }

                @media screen and (max-width: 576px) {
                    .section-title {
                        font-size: 32px;
                        max-width: 306px;
                    }
                }

                * {
                    font-family: 'Figtree';
                }
            `}</style>
        </div>
    );
}

export default Introduction;